<template>
  <div class="main-conent main-conent-maxheight page-label">
    <right
      :device-id="deviceId"
      :pictures="pictures"
      :detail="detail"
      :insects="insects"
      :default-label="defaultLabel"
      :show-label="showLabel"
      :insect-index="activedInsectIndex"
      :cates="cates"
      @set-default="setDefault"
      @set-show-label="setShowLabel"
      @set-device="setDevice"
      @set-insect="setInsectActive"
      @get-detail="getDetail"
      @remove="removeInsect"
      @edit-insect="editInsect"
    ></right>

    <n-main
      ref="viewer"
      :picture="detail"
      :insects="insects"
      :creating="creatingLabel"
      :active="activedInsectIndex"
      :show-label="showLabel"
      @loaded="imgLoaded"
      @set-active="setInsectActive"
      @create="addLabel"
      @update="setInsect"
      @scale-change="scaleChange"
    ></n-main>

    <files
      :pictures="pictures"
      :actived="actived"
      @get-detail="getDetail"
    ></files>

    <left
      :prev="prev"
      :next="next"
      :scale="scale"
      :min-scale="minScale"
      :date="day"
      :date-count="dateCount"
      :creating="creatingLabel"
      :active="activedInsectIndex"
      :edited="edited"
      :loading="loadingCount"
      :recognizing="recognizing"
      @go="goActive"
      @zoom="zoom"
      @fit-window="fitWindow"
      @day-change="getDay"
      @month-change="monthChange"
      @add-label="preAddLabel"
      @remove="removeInsect"
      @copy="preCopy"
      @save="updateInsects"
      @download-txt="downloadTxt"
      @download="downloadPic"
      @triggle-uploader="triggleUploader"
      @recognize="recognize"
    ></left>

    <uploader
      :visible.sync="uploaderVisible"
      :device-id="deviceId"
      @get-day="getDay"
    ></uploader>
  </div>
</template>

<script>
import Left from './left'
import NMain from './main/index'
import Right from './right'
import Files from './right/fileList'
import Uploader from './uploader'

import cloneDeep from 'lodash/cloneDeep'
import { formatDate, add } from '@/utlis/date'
import { getPictures, getDetail, getDateCount } from '@/service/telemetry'
import { update as updateReview, recognize } from '@/service/insect'
import { device as getCates } from '@/service/category'
import sleep from '@/utlis/sleep'

import html2canvas from 'html2canvas'

export default {
  components: { Left, NMain, Right, Files, Uploader },
  data() {
    return {
      prev: -1,
      next: -1,
      defaultLabel: null,
      showLabel: -1,
      deviceId: null,
      loading: false,
      loadingCount: false,
      day: null,
      page: 0,
      limit: 200,
      pictures: [],
      dateCount: [],
      cates: [],
      insects: [],
      origInsects: [],
      detail: {},
      activedInsectIndex: -1,
      actived: 0,
      minScale: 100, // 百分比
      imgWidth: 1920,
      imgheight: 1080,
      scale: 0, // 图片缩放 百分比
      creatingLabel: false, // 画标注中
      continueCreating: false, // 持续添加
      uploaderVisible: false, // 是否显示上传
      recognizing: false
    }
  },
  computed: {
    edited() {
      const edited = !(
        this.origInsects.length === this.insects.length &&
        this.origInsects.every(o => {
          const insect = this.insects.find(i => i.id === o.id)
          return (
            insect &&
            insect.headPositionX === o.headPositionX &&
            insect.headPositionY === o.headPositionY &&
            insect.tailPositionX === o.tailPositionX &&
            insect.tailPositionY === o.tailPositionY &&
            insect.categoryId === o.categoryId &&
            insect.state === o.state
          )
        })
      )
      return edited
    }
  },
  created() {
    this.setDevice(this.teles && this.teles[0] ? this.teles[0].id : null)
    window.addEventListener('keydown', this.keyDown)
    window.addEventListener('keyup', this.initEvt)
  },
  methods: {
    keyDown(e) {
      if (e.keyCode === 16) {
        this.continueCreating = true
        this.creatingLabel = true
      }
    },
    initEvt(e) {
      if (e.keyCode === 46 && this.activedInsectIndex >= 0) {
        this.removeInsect(this.activedInsectIndex)
      }
      if (e.keyCode === 16) {
        this.continueCreating = false
        this.creatingLabel = false
      }
    },
    initDay(pic) {
      if (pic) {
        const createdAt = new Date(pic.createdAt)
        const hour = createdAt.getHours()
        if (hour >= 8) {
          return add(createdAt, 1, 'days', 'YYYY-MM-DD')
        } else {
          return formatDate(createdAt, 'YYYY-MM-DD')
        }
      }
    },
    async getPicture(day) {
      this.loading = true

      const query = {
        deviceId: this.deviceId,
        beginDate: day || 'lastDay',
        endDate: day,
        page: 1,
        limit: this.limit
      }
      const { data } = await getPictures(this.companyId, query)
      const { paging, pictures } = data
      this.total = paging.count
      this.page = paging.page
      this.pictures = pictures

      if (pictures && pictures[0]) {
        this.getInsects(pictures[0].id, query)
      } else {
        this.clearDetail()
        this.loading = false
      }

      if (!day) {
        this.day = this.initDay(pictures && pictures[0])
      }
    },
    async getInsects(id, query = {}) {
      const idx = this.pictures.findIndex(p => p.id === id)
      this.prev = idx - 1
      this.next = idx + 1 > this.pictures.length - 1 ? -1 : idx + 1
      this.actived = idx

      if (!this.day) {
        this.day = formatDate(this.pictures[0].createdAt, 'YYYY-MM-DD')
        query.beginDate = this.day
        query.endDate = this.day
      }
      const { insects, picture } = await getDetail(id, query).then(
        res => res.data
      )

      this.detail = picture
      this.insects = cloneDeep(insects)
      this.origInsects = insects
      // this.prev = prev // 上面 pictures.reverse()
      // this.next = next // 上面 pictures.reverse()
      this.loading = false
    },
    async updateInsects() {
      this.loading = true
      const id = this.detail.id
      const update = this.insects.filter(i => i.id && i.dirty)
      const create = this.insects.filter(i => !i.id)
      const remove = this.origInsects.filter(
        i => !this.insects.find(ii => ii.id === i.id)
      )

      const { data, code } = await updateReview(id, {
        create,
        update,
        remove
      })

      this.loading = false

      if (code) {
        this.origInsects = data.insects
        this.insects = cloneDeep(data.insects)
        const index = this.pictures.findIndex(p => p.id === id)
        this.pictures.splice(index, 1, {
          ...this.pictures[index],
          distinguishCount: data.insects.length
        })

        this.$message.success('保存完成')
      }
    },
    async getDateCount(month) {
      this.loadingCount = true
      const [{ data }] = await Promise.all([
        getDateCount(this.deviceId, month),
        sleep(0.5)
      ])
      this.loadingCount = false
      this.dateCount = data
    },
    async getCates(id) {
      this.loading = true
      const [{ data }] = await Promise.all([getCates(id), sleep(0.5)])

      if (data && data.length) {
        this.cates = data
        this.defaultLabel = data[0].id
      } else {
        this.cates = []
        this.defaultLabel = null
      }

      this.loading = false
    },
    getDetail(id) {
      this.getInsects(id, {
        deviceId: this.deviceId,
        beginDate: this.day,
        endDate: this.day,
        page: 1,
        limit: this.limit
      })
    },
    goActive(idx) {
      const pic = this.pictures[idx]
      if (pic) {
        this.getDetail(pic.id)
      }
    },
    clearDetail() {
      this.detail = {}
      this.insects = []
      this.origInsects = []
      this.prev = -1
      this.next = -1
    },
    setInsectActive(index) {
      this.activedInsectIndex = index
    },
    setDefault(id) {
      this.defaultLabel = id
    },
    setShowLabel(id) {
      this.showLabel = id
    },
    setDevice(id) {
      if (!id) return
      this.deviceId = id
      this.clearDetail()
      this.getPicture()
      this.getCates(id)
    },
    imgLoaded(min, w, h) {
      this.minScale = min * 100
      this.imgWidth = w
      this.imgHeight = h
      this.fitWindow()
    },
    zoom(scale) {
      this.scale = scale
      this.$refs.viewer.zoom(scale)
    },
    fitWindow() {
      this.scale = this.minScale
      this.$refs.viewer.fit(this.scale)
    },
    scaleChange(scale) {
      this.scale = scale * 100
    },
    getDay(day) {
      this.day = day
      this.getPicture(day)
    },
    monthChange(m) {
      this.getDateCount(m)
    },
    preAddLabel() {
      this.creatingLabel = !this.creatingLabel
    },
    addLabel(bound) {
      const insect = this.cates.find(c => c.id === this.defaultLabel)
      if (insect) {
        this.insects.push({
          ...bound,
          pictureId: this.detail.id,
          categoryId: insect.id,
          category: insect.name,
          state: 2
        })
        this.activedInsectIndex = this.insects.length - 1
        if (!this.continueCreating) {
          this.preAddLabel()
        }
      }
    },
    setInsect(index, bound) {
      const insect = this.insects[index]
      if (insect) {
        this.insects.splice(index, 1, { ...insect, ...bound, dirty: true })
      }
    },
    removeInsect(index) {
      this.insects.splice(index, 1)
      if (this.activedInsectIndex >= this.insects.length) {
        this.activedInsectIndex = this.insects.length - 1
      }
    },
    preCopy(index) {
      const insect = this.insects[index]
      if (insect) {
        this.insects.push({ ...insect, _id: Date.now(), id: null })
        this.activedInsectIndex = this.insects.length - 1
      }
    },
    editInsect(index, item) {
      const insect = this.insects[index]
      if (insect && item) {
        insect.categoryId = item.id
        insect.category = item.name
        insect.dirty = true
        insect.state = 2
        this.insects.splice(index, 1, insect)
      }
    },
    downloadBtn(url, name) {
      // const btn = document.createElement('a')
      // btn.setAttribute('href', url)
      // if (name) btn.setAttribute('download', name)
      // btn.style.display = 'none'
      // let evt = document.createEvent('mouseevents')
      // evt.initMouseEvent('click', false, false)
      // btn.dispatchEvent(evt)
      // document.body.appendChild(btn)
      // return btn
      let el = document.getElementsByClassName('label-img-container')[0]
      html2canvas(el).then(canvas => {
        const imUrl = canvas.toDataURL('image/jpeg')
        let link = document.createElement('a')
        link.setAttribute('download', name)
        link.href = imUrl
        link.click()
      })
    },
    downloadTxt() {
      const arr = /^\/origPic\/(\S+.jpg)/.exec(this.detail.storePath)

      if (arr && arr[1]) {
        const name = `${arr[1]}.txt`
        const w = this.imgWidth
        const h = this.imgHeight
        const cates = this.insects.reduce((arr, cur) => {
          const idx = arr.findIndex(i => i.categoryId === cur.categoryId)
          if (idx >= 0) {
            arr[idx].insects.push(cur)
            return arr
          } else {
            arr.push({
              categoryId: cur.categoryId,
              name: cur.category,
              insects: [cur]
            })
            return arr
          }
        }, [])

        const content = cates
          .map(cate => {
            const position = cate.insects.map(ins => {
              const {
                headPositionX: hx,
                headPositionY: hy,
                tailPositionX: tx,
                tailPositionY: ty
              } = ins
              return [
                Math.ceil(hx * w),
                Math.ceil(hy * h),
                Math.ceil((tx - hx) * w),
                Math.ceil((ty - hy) * h)
              ]
            })
            return `${cate.name}\n识别数：${
              cate.insects.length
            }\n识别坐标：\n${JSON.stringify(position)}\n`
          })
          .join('\n')

        this.downloadBtn(
          'data:text/plain;charset=utf-8,' + encodeURIComponent(content),
          name
        )
      }
    },
    downloadPic() {
      const arr = /^\/origPic\/(\S+.jpg)/.exec(this.detail.storePath)
      if (arr && arr[1]) {
        this.downloadBtn(this.detail.storePath, arr[1])
      }
    },

    triggleUploader() {
      this.uploaderVisible = !this.uploaderVisible
    },
    async recognize() {
      if (this.detail && this.detail.storePath) {
        this.recognizing = true
        const image = 'http://data.pengbo-tech.com' + this.detail.storePath
        const { data } = await recognize(this.detail.key, image)
        const { imgWidth: w, imgHeight: h, cates } = this
        const ids = cates.map(c => c.id)

        const insects = data
          .filter(insect => ids.includes(+insect.id))
          .map((insect, idx) => {
            return {
              headPositionX: insect.box[0][0] / w,
              headPositionY: insect.box[0][1] / h,
              tailPositionX: insect.box[1][0] / w,
              tailPositionY: insect.box[1][1] / h,
              pictureId: this.detail.id,
              categoryId: insect.id,
              category: insect.name,
              state: 2,
              _id: Date.now() + idx
            }
          })

        this.insects = cloneDeep(insects)
        this.activedInsectIndex = this.insects.length - 1
        this.recognizing = false
      }
    }
  }
}
</script>

<style lang="css" scoped>
.page-label {
  display: flex;
  overflow: hidden;
}
</style>
